import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ProjectDetails.css';
import numeral from 'numeral';
import { simpleScrollToTop } from 'services/utils/scroller-util';
import RouteTitle from 'components/shared/route-title/RouteTitle';
import NavigationBar from 'components/shared/navigation/NavigationBar';
import DetailsHeader from 'components/shared/details/DetailsHeader';
import Video from 'components/shared/video/Video';
import {
  initProjectDetails,
  loadProjectRequest,
  selectNavigationBar,
  setShowPdfViewer,
} from 'components/admin/projects/details/store/actions';
import LogoUpload from 'components/shared/logo-upload/LogoUpload';
import {
  getCurrentProject,
  getNavBarSelectedItem,
  getShowPdfViewer,
} from 'components/admin/projects/details/store/selectors';
import {
  getProjectOpenItemsCount,
  getProjectOpenItemsCritCount,
} from 'components/admin/projects/details/project-open-items/store/selectors';
import { getCloseoutPercentage } from 'components/admin/projects/details/project-closeout/store/selectors';
import { getSubDailyReportsCount } from 'components/admin/projects/details/project-daily-report-log/store/selectors';
import { openMeeting } from 'components/admin/projects/details/project-meeting-minutes/store/actions';
import { openRfi } from 'components/admin/projects/details/project-rfi-log/store/actions';
import { openSubmittal } from 'components/admin/projects/details/project-submittal-log/store/actions';
import {
  openDraftReport,
  setDailyReportTab,
  loadFieldWorkOrdersRequest,
  openFieldWorkOrder,
} from 'components/admin/projects/details/project-daily-report-log/store/actions';
import {
  showOpenItemsModal,
  loadOpenItem,
  openItemsCount,
  initOpenItemsCount,
} from 'components/admin/projects/details/project-open-items/store/actions';
import { closeoutPercentage } from 'components/admin/projects/details/project-closeout/store/actions';
import {
  subDailyReportsCount,
  initSubDailyReportsCount,
} from 'components/admin/projects/details/project-daily-report-log/store/actions';
import DetailsInfoCard from 'components/shared/details/DetailsInfoCard';
import ProjectProposal from 'components/admin/projects/details/project-proposal/ProjectProposal';
import ProjectDirectory from 'components/admin/projects/details/project-directory/ProjectDirectory';
import ProjectMeetingMinutes from 'components/admin/projects/details/project-meeting-minutes/ProjectMeetingMinutes';
import ProjectRfiLog from 'components/admin/projects/details/project-rfi-log/ProjectRfiLog';
import ProjectSubmittalLog from 'components/admin/projects/details/project-submittal-log/ProjectSubmittalLog';
import ProjectDailyReportLog from 'components/admin/projects/details/project-daily-report-log/ProjectDailyReportLog';
import ProjectDocumentation from 'components/admin/projects/details/project-documentation/ProjectDocumentation';
import ProjectOpenItemsModal from 'components/admin/projects/details/project-open-items/ProjectOpenItemsModal';
import ProjectCloseout from 'components/admin/projects/details/project-closeout/ProjectCloseout';
import CoiExps from 'components/admin/projects/details/project-coi-exps/CoiExps';
import { ProjectStatusEnum } from 'domain/project-status-enum';
import groupPng from 'images/group.png';
import groupSelectedPng from 'images/group-selected.png';
import { getCurrentUser } from 'selectors/authentication';
import { Enterprise } from 'domain/enterprise';
import { goToEditProject } from 'components/admin/projects/store/actions';
import Number from 'components/shared/text/Number';
import queryString from 'query-string';
import Button from 'components/shared/button/Button';
import {
  Tooltip,
  OverlayTrigger,
  Button as ReactButton,
} from 'react-bootstrap';
import {
  setShowLostModal,
  setShowCancelModal,
} from 'components/admin/projects/details/project-proposal/store/actions';
import Date from 'components/shared/text/Date';
import { usersUtil, TYPES } from 'services/utils/users-util';
import moment from 'moment';
import PdfViewer from 'components/shared/pdf-viewer/PdfViewer';

class ProjectDetails extends Component {
  constructor(props) {
    super(props);

    props.dispatch(initProjectDetails());
    props.dispatch(initOpenItemsCount());
    props.dispatch(initSubDailyReportsCount());
    this.showActions = Enterprise.showActions(props.currentUser);
    this.subcontractor = usersUtil.hasType(props.currentUser, TYPES.CONTRACTOR);
  }

  componentDidMount() {
    this.loadProjectDetails(this.props);
    this.displayEmailPdf();
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const newProjectId = numeral(newProps.match.params.projectId).value();
    if (
      this.projectId !== newProjectId ||
      this.props.location !== newProps.location
    ) {
      this.loadProjectDetails(newProps);
    }
  }

  loadProjectDetails = (props) => {
    const prevProjectId = this.projectId;
    this.projectId = numeral(props.match.params.projectId).value();
    props.dispatch(loadProjectRequest(this.projectId)).then((response) => {
      const { currentUser, location, dispatch } = props;
      const state =
        location && (location.state || queryString.parse(location.search));
      prevProjectId !== this.projectId && this.handleNavigationItemSelect(null);
      if (state && Object.keys(state).length > 0) {
        if (state.meetingId) {
          this.handleNavigationItemSelect(3);
          dispatch(openMeeting(this.projectId, state.meetingId));
        } else if (state.rfiId) {
          this.handleNavigationItemSelect(4);
          dispatch(openRfi(this.projectId, state.rfiId));
        } else if (state.submittalId) {
          this.handleNavigationItemSelect(5);
          dispatch(
            openSubmittal(this.projectId, state.submittalId, currentUser)
          );
        } else if (state.dailyReportId) {
          this.handleNavigationItemSelect(6);
          dispatch(
            openDraftReport(
              this.projectId,
              state.dailyReportId,
              state.subDailyReport,
              true
            )
          );
        } else if (state.fieldWorkOrderId) {
          this.handleNavigationItemSelect(6);
          dispatch(setDailyReportTab(3));
          dispatch(loadFieldWorkOrdersRequest(this.projectId, 1));
          dispatch(openFieldWorkOrder(this.projectId, state.fieldWorkOrderId));
        } else if (state.projectOpenItemId) {
          state.projectOpenItemCritical
            ? this.onCriticalOpenItemsClick()
            : this.onOpenItemsClick();
          dispatch(loadOpenItem(this.projectId, state.projectOpenItemId));
        } else if (state.documentation) {
          this.handleNavigationItemSelect(7);
        } else if (state.closeout) {
          this.handleNavigationItemSelect(8);
        } else {
          this.handleNavigationItemSelect(1);
        }
      } else {
        this.handleNavigationItemSelect(1);
      }
    });
    props.dispatch(openItemsCount(this.projectId));
    props.dispatch(closeoutPercentage(this.projectId));
    this.subcontractor && props.dispatch(subDailyReportsCount(this.projectId));
  };

  handleNavigationItemSelect = (value) => {
    simpleScrollToTop();
    this.props.dispatch(selectNavigationBar(value));
  };

  handleShowLostModal = (e) => {
    const projStatus = ProjectStatusEnum.create(
      this.props.currentProject.status
    );
    if (ProjectStatusEnum.LOST.equals(projStatus)) {
      this.props.dispatch(setShowLostModal(true));
    } else if (ProjectStatusEnum.CANCELLED.equals(projStatus)) {
      this.props.dispatch(setShowCancelModal(true));
    }
    e && e.stopPropagation();
  };

  projectApproved = () => {
    const projStatus = ProjectStatusEnum.create(
      this.props.currentProject.status
    );
    return !ProjectStatusEnum.PENDING.equals(projStatus);
  };

  detailsInfoCards = () => {
    const { currentProject } = this.props;
    let detailsInfoCards = [
      [
        'CLIENT',
        currentProject.client.company_name,
        this.showActions ? (
          <a className="edit-project-details" onClick={this.onEditClick}>
            Edit Details
          </a>
        ) : (
          ''
        ),
      ],
    ];

    currentProject.client.logo &&
      currentProject.client.logo.image &&
      detailsInfoCards.push([
        <div className="logo-preview-container">
          <LogoUpload
            extensions={['.jpg', '.jpeg', '.gif', '.png']}
            logos={[
              {
                preview: currentProject.client.logo.image.url,
                url: currentProject.client.logo.image.url,
              },
            ]}
            readOnly={true}
          />
        </div>,
      ]);

    detailsInfoCards.push(
      [
        'ADDRESS',
        currentProject.building.location.street_address_1,
        currentProject.building.location.street_address_2,
        `${currentProject.building.location.city}, ${currentProject.building.location.state} ${currentProject.building.location.zip}`,
      ],
      [
        'INFO',
        <div>
          {' '}
          Sq. Footage: <Number
            value={currentProject.sq_footage}
            format="0,0"
          />{' '}
          ft.{' '}
        </div>,
        `Project #: ${currentProject.number}`,
      ]
    );

    if (
      currentProject.building.property_owner_name ||
      currentProject.building.property_owner_address
    ) {
      detailsInfoCards.push([
        'PROPERTY OWNER',
        currentProject.building.property_owner_name,
        currentProject.building.property_owner_address &&
          currentProject.building.property_owner_address.street_address_1,
        currentProject.building.property_owner_address &&
          currentProject.building.property_owner_address.street_address_2,
        currentProject.building.property_owner_address &&
          `${currentProject.building.property_owner_address.city}` +
            `, ${currentProject.building.property_owner_address.state}` +
            `, ${currentProject.building.property_owner_address.zip}`,
      ]);
    }

    if (
      currentProject.vlog &&
      currentProject.vlog_start_date &&
      currentProject.vlog_end_date
    ) {
      detailsInfoCards.push([
        <div className="project-vlog">
          <div>
            VLOG UPDATE
            <br />
            <div className="vlog-dates">
              {`${moment(currentProject.vlog_start_date).format('M/D')}-`}
              {moment(currentProject.vlog_end_date).format('M/D')}
              {currentProject.walk_thru_url &&
                currentProject.walk_thru_url_preview && (
                  <div>
                    <a href={currentProject.walk_thru_url} target="_blank">
                      {currentProject.walk_thru_url_preview}
                    </a>
                  </div>
                )}
            </div>
          </div>
          <div>
            <Video video={currentProject.vlog} />
          </div>
        </div>,
      ]);
    }

    return detailsInfoCards;
  };

  onCriticalOpenItemsClick = (e) => {
    const { currentProject, dispatch } = this.props;
    dispatch(showOpenItemsModal(currentProject.id, 1, true));
    e && e.stopPropagation();
  };

  onOpenItemsClick = (e) => {
    const { currentProject, dispatch } = this.props;
    dispatch(showOpenItemsModal(currentProject.id, 1, false));
    e && e.stopPropagation();
  };

  detailsInfoCardButtons = () => {
    const { projectOpenItemsCount, projectOpenItemsCritCount } = this.props;
    return [
      <Button
        className="button-orange"
        label={`Critical${
          projectOpenItemsCritCount !== null
            ? `\xa0\xa0(${projectOpenItemsCritCount})`
            : ''
        }`}
        onClick={this.onCriticalOpenItemsClick}
      />,
      <Button
        className="button-blue-grey"
        label={`Open Items${
          projectOpenItemsCount !== null
            ? `\xa0\xa0(${projectOpenItemsCount})`
            : ''
        }`}
        onClick={this.onOpenItemsClick}
      />,
    ];
  };

  detailsInfoExtraHeader = () => {
    const { currentProject } = this.props;
    return [
      <div className="project-status">
        {currentProject.termination_reason && (
          <OverlayTrigger
            placement="bottom"
            overlay={this.tooltip(currentProject)}
          >
            <ReactButton
              onClick={this.handleShowLostModal}
              className={`uppercase status-text ${currentProject.status} btn button`}
            >
              {ProjectStatusEnum.create(
                currentProject.status
              ).label.toUpperCase()}
            </ReactButton>
          </OverlayTrigger>
        )}
        {!currentProject.termination_reason && (
          <ReactButton
            className={`uppercase status-text ${currentProject.status} btn button`}
          >
            {ProjectStatusEnum.create(
              currentProject.status
            ).label.toUpperCase()}
          </ReactButton>
        )}
        {currentProject.bid_due_date && !this.projectApproved() && (
          <span className="bid-due-date">
            {' '}
            BID DUE DATE:{' '}
            <Date
              className="bid-due-date-date"
              value={currentProject.bid_due_date}
              format="MM/DD/YY"
            />
          </span>
        )}
      </div>,
    ];
  };

  onEditClick = () => {
    this.props.dispatch(goToEditProject(this.props.currentProject.id));
  };

  tooltip = (currentProject) => {
    const tooltipData = (
      <Tooltip placement="right" className="in" id="tooltip-right">
        {currentProject.termination_category}{' '}
        {currentProject.termination_reason}
      </Tooltip>
    );
    return tooltipData;
  };

  displayEmailPdf = () => {
    let params = new URL(document.location).searchParams;
    if (params.get('show_pdf_view') === 'true') {
      this.setState({ pdf_url: params.get('pdf_url') });
      this.props.dispatch(setShowPdfViewer(true));
    }
  };

  handlePdfViewerClose = () => {
    this.props.dispatch(setShowPdfViewer(false));
  };

  render() {
    const {
      currentProject,
      closeoutPercentage,
      subDailyReportsCount,
      showPdfViewer,
    } = this.props;
    const projectApproved = currentProject && this.projectApproved();
    const detailsInfoCards = (currentProject && this.detailsInfoCards()) || [];
    const detailsInfoCardButtons =
      (projectApproved && this.detailsInfoCardButtons()) || [];
    const detailsInfoExtraHeader =
      (currentProject && this.detailsInfoExtraHeader()) || [];
    return (
      <div>
        {currentProject && (
          <div className="project-details">
            <div className="title-container">
              <RouteTitle titles={['PROJECTS', currentProject.name]} />
            </div>

            <DetailsHeader
              leftHeader={{
                title: 'PROJECT',
                value: currentProject.name,
              }}
              rightHeaders={
                currentProject.general_contractor.logo &&
                currentProject.general_contractor.logo.image
                  ? [
                      [
                        {
                          value: (
                            <div className="logo-preview-container">
                              <LogoUpload
                                extensions={['.jpg', '.jpeg', '.gif', '.png']}
                                logos={[
                                  {
                                    preview:
                                      currentProject.general_contractor.logo
                                        .image.url,
                                    url:
                                      currentProject.general_contractor.logo
                                        .image.url,
                                  },
                                ]}
                                readOnly={true}
                              />
                            </div>
                          ),
                        },
                      ],
                    ]
                  : []
              }
            />

            <DetailsInfoCard
              itemLines={detailsInfoCards}
              headerButtons={detailsInfoCardButtons}
              leftHeaderExtraComponents={detailsInfoExtraHeader}
            />

            <div className="content-container">
              <NavigationBar
                items={[
                  {
                    id: 1,
                    title: projectApproved ? 'Schedule of Values' : 'Proposal',
                  },
                  {
                    id: 2,
                    title: (
                      <span>
                        <img
                          src={
                            this.props.navBarSelectedItem === 2
                              ? groupSelectedPng
                              : groupPng
                          }
                          alt="Directory"
                        />
                        <span className="directory-title">Directory</span>
                      </span>
                    ),
                    class: 'navigation-directory',
                    show: projectApproved,
                  },
                  {
                    id: 7,
                    title: 'Documents',
                    show: projectApproved,
                    total:
                      this.subcontractor ||
                      currentProject.advanced_document_view
                        ? null
                        : currentProject.documents_count,
                  },
                  {
                    id: 9,
                    title: 'COI',
                    show: projectApproved,
                  },
                  {
                    id: 3,
                    title: 'Meeting Minutes',
                    show: projectApproved && !this.subcontractor,
                    total: currentProject.meetings_count,
                  },
                  {
                    id: 4,
                    title: 'RFIs',
                    show: projectApproved,
                    total: currentProject.rfis_count,
                  },
                  {
                    id: 5,
                    title: 'Submittals',
                    show: projectApproved,
                    total: currentProject.submittals_count,
                  },
                  {
                    id: 6,
                    title: 'Daily Reports',
                    show: projectApproved,
                    total: this.subcontractor
                      ? subDailyReportsCount
                      : currentProject.daily_reports_count,
                  },
                  {
                    id: 8,
                    title: 'Closeout',
                    show: projectApproved,
                    total: `${closeoutPercentage}%`,
                  },
                ]}
                selectedValue={this.props.navBarSelectedItem}
                onSelected={this.handleNavigationItemSelect}
              />

              <div className="separator">
                <div className="clearfix" />
              </div>

              {/*Navigation bar items content*/}
              {this.props.navBarSelectedItem === 1 && <ProjectProposal />}
              {this.props.navBarSelectedItem === 2 && <ProjectDirectory />}
              {this.props.navBarSelectedItem === 3 && <ProjectMeetingMinutes />}
              {this.props.navBarSelectedItem === 4 && <ProjectRfiLog />}
              {this.props.navBarSelectedItem === 5 && <ProjectSubmittalLog />}
              {this.props.navBarSelectedItem === 6 && <ProjectDailyReportLog />}
              {this.props.navBarSelectedItem === 7 && <ProjectDocumentation />}
              {this.props.navBarSelectedItem === 8 && <ProjectCloseout />}
              {this.props.navBarSelectedItem === 9 && <CoiExps />}
            </div>

            <ProjectOpenItemsModal />

            {showPdfViewer && (
              <PdfViewer
                content={{
                  source: this.state.pdf_url,
                  type: 'url',
                }}
                show={showPdfViewer}
                onClose={this.handlePdfViewerClose}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}
export default connect((state) => {
  return {
    currentProject: getCurrentProject(state),
    navBarSelectedItem: getNavBarSelectedItem(state),
    currentUser: getCurrentUser(state),
    projectOpenItemsCount: getProjectOpenItemsCount(state),
    projectOpenItemsCritCount: getProjectOpenItemsCritCount(state),
    closeoutPercentage: getCloseoutPercentage(state),
    subDailyReportsCount: getSubDailyReportsCount(state),
    showPdfViewer: getShowPdfViewer(state),
  };
})(ProjectDetails);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/ProjectDetails.js